import { Link } from 'react-router-dom';
import { ShieldCheck, ArrowUpRight } from 'lucide-react';
import { Reveal } from './Shared';
import { metrics, metricsConfig } from '../data/metrics';
import { company } from '../data/content';
import { L } from '../i18n/LocaleProvider';

export const ProofStrip = () => <L><section className="container proof-strip-section" aria-label="Proof points">
  <Reveal className="proof-strip" data-testid="home-proof-strip">
    <div className="proof-stats">
      {metricsConfig.heroKeys.map(key => <div className="proof-stat" key={key} data-testid={`proof-stat-${key}`}>
        <strong>{metrics[key].value}{metrics[key].suffix || ''}</strong>
        <span>{metrics[key].label}</span>
      </div>)}
    </div>
    <div className="proof-partner" data-testid="proof-partner-line"><ShieldCheck size={15} aria-hidden="true" /><span>{company.partnerLine}</span></div>
    <Link to="/case-studies" className="proof-link" data-testid="proof-case-studies-link">See the results <ArrowUpRight size={15} /></Link>
  </Reveal>
</section></L>;
